'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var jsonp = require('jsonp');
var cookie = require('react-cookie');

var GetPhoneNumber = function GetPhoneNumber(BaseComponent) {
  return function (_BaseComponent) {
    _inherits(GetPhoneNumberClass, _BaseComponent);

    GetPhoneNumberClass.prototype.getPhoneNumber = function getPhoneNumber(callback) {
      var _this2 = this;

      if (!callback || typeof callback !== 'function') return;
      var _state = this.state,
          agentData = _state.agentData,
          phoneNumbers = _state.phoneNumbers;
      var settings = this.props.settings;

      var phoneNumberData = this.getDefaultNumber();
      var product = agentData.typeRID === 'I' ? 'ADMccI' : 'ADMcc';

      var requestUrl = 'prodlib-multi?noCache=1&product=' + product;
      jsonp(settings.soapiBase + requestUrl, function (err, res) {
        if (err || !(res[0] && _typeof(res[0]) === 'object')) return callback(phoneNumberData);
        var data = res[0];
        if (!data.hasOwnProperty('number')) return callback(phoneNumberData);
        if (agentData.typeRID !== 'I') {
          var _getDefaultNumber = _this2.getDefaultNumber(data.number),
              number = _getDefaultNumber.number;

          data.number = number;
        }
        callback(data);
      });
    };

    GetPhoneNumberClass.prototype.getDefaultNumber = function getDefaultNumber(givenNumber) {
      var agentData = this.state.agentData;
      var _props$agents = this.props.agents,
          fallBackPhoneNumber = _props$agents.fallBackPhoneNumber,
          defaultPhoneNumbers = _props$agents.defaultPhoneNumbers,
          agent = _props$agents.agent;

      var phoneNumberData = { number: fallBackPhoneNumber };

      if (defaultPhoneNumbers && defaultPhoneNumbers.hasOwnProperty(agentData.agent)) {
        phoneNumberData.number = defaultPhoneNumbers[agentData.agent];
      } else if (agentData.hasOwnProperty('DDI') && agentData.DDI !== '') {
        phoneNumberData.number = agentData.DDI;
      } else if (givenNumber) {
        phoneNumberData.number = givenNumber;
      }
      return phoneNumberData;
    };

    GetPhoneNumberClass.prototype.componentDidUpdate = function componentDidUpdate() {
      var _state2 = this.state,
          agentData = _state2.agentData,
          prevPhoneNumbers = _state2.phoneNumbers;

      var self = this;
      this.getPhoneNumber(function (phoneNumbers) {
        if (!(phoneNumbers && phoneNumbers.hasOwnProperty('number'))) return;
        if (prevPhoneNumbers.message && prevPhoneNumbers.number === phoneNumbers.number) return;
        self.setState({
          phoneNumbers: phoneNumbers
        });
      });
    };

    function GetPhoneNumberClass(props) {
      _classCallCheck(this, GetPhoneNumberClass);

      var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, props));

      BaseComponent.bind(_this);
      _this.state.phoneNumbers = _this.getDefaultNumber();
      return _this;
    }

    return GetPhoneNumberClass;
  }(BaseComponent);
};

module.exports = GetPhoneNumber;


// WEBPACK FOOTER //
// ./_plugins/lib/phoneNumber.js